import type { FunctionComponent } from "react";
import { Route, Routes } from "react-router-dom";
import { Location } from "@App/Pages/Common/Location";
import { useServiceFunnel } from "@App/hooks/useServiceFunnel";

/**
 * The funnel for the general catch-all "appointment" service.
 *
 * @constructor
 */
export const Appointment: FunctionComponent = () => {
  const { navigateWithQuery } = useServiceFunnel("termin");

  return (
    <Routes>
      <Route
        path={"/"}
        element={
          <Location
            headline={"Jetzt ganz einfach Werkstatt-Termin buchen"}
            subheadline={"Wo suchst du eine Werkstatt?"}
            description={"Wir suchen nach Werkstatten in Deiner Nähe."}
            step={1}
            maxSteps={9}
            onSubmit={() => navigateWithQuery(`werkstaetten`)}
          />
        }
      />
    </Routes>
  );
};
